import { defineAsyncComponent } from 'vue'
export default {
  anonymous: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/anonymous.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m))
}